import App from './App.vue'
import VueRouter from 'vue-router'
import routes from '@/router'
import { request, api } from "@/plugin/index.js";  //封装的axios请求和接口地址
import AllUI from './components'
import AllService from './service'
import './components/theme/index.scss'
import InitSentrt from './plugin/sentry.js'
/**
 * 等待allBridge加载完成在执行指定动作
 */

function allReadydo() {
    return new Promise((resolve) => {
        try {
            window.__allReadydo((allBridge) => {
                if (Vue.prototype.$UI === undefined) {
                    Vue.use(AllUI)
                }
                if (Vue.prototype.$Service === undefined) {
                    Vue.use(AllService)
                }

                resolve(allBridge);
            })
        } catch (error) {
            console.error('main.js', 'allReadydo', error)
        }
    })
}
// allReadydo()
/**
 * TODO: 回头切到Bridge里
 * 营销统一埋点框架上报方法
 * @param {String} category 
 * @param {String} action 
 * @param {String} label 
 * @param {String} value 
 */
function marketingTraceLog(category, action, label, value, from) {
    try {
        if (window.__marketing_trace_log && typeof __marketing_trace_log.report == 'function') {
            return __marketing_trace_log.report(category, action, label, value, true);
        } else {
            if (from !== 'none') {
                setTimeout(() => {
                    marketingTraceLog(category, action, label, value, 'none')
                }, 100);
            } else {
                // console.warn('main.js', 'marketingTraceLog', '营销统一埋点框架未加载完成，本次上报数据失败', { category, action, label, value });
            }
        }
    } catch (error) {
        console.error('main.js', 'marketingTraceLog', error);
    }
}

function sendErrorInfo(from, err, vm, info) {
    if (from === 'warnHandler') {
        // console.warn(err);
    } else {
        console.error(err);
    }

    function getNodeInfoFromVM(vm) {
        // 主要是看当前dom节点上是否有组件信息，没有的话就再往上找
        if (!vm) {
            return
        }

        const nodeInfo = vm.$parent && vm.$parent.nodeInfo;
        const nodeId = nodeInfo && nodeInfo.id;
        const nodeLabel = nodeInfo && nodeInfo.label;
        const nodeType = nodeInfo && nodeInfo.type;
        const nodeVersion = nodeInfo && nodeInfo.version;
        const nodeCalcSuccessExpression = nodeInfo && nodeInfo.calcSuccessExpression;

        if (nodeId && nodeType && nodeVersion) {
            return {
                nodeId,
                nodeLabel,
                nodeType,
                nodeVersion,
                nodeCalcSuccessExpression
            }
        } else {
            return getNodeInfoFromVM(vm.$parent)
        }
    }

    function getData(data) {
        if (data && typeof data === 'object') {
            const keys = Object.keys(data);
            const results = {}
            for (const key of keys) {
                const value = data[key]
                if (typeof value === 'object') {
                    try {
                        JSON.parse(value)
                        results[key] = value
                    } catch (error) {
                        continue
                    }
                } else if (typeof value === 'function') {
                    results[key] = '$function'
                } else {
                    results[key] = value
                }
            }

            return results
        } else {
            return typeof data === '$function' ? 'function' : data
        }
    }

    const nodeInfo = getNodeInfoFromVM(vm);
    const nodeId = nodeInfo && nodeInfo.nodeId
    const nodeLabel = nodeInfo && nodeInfo.label;
    const nodeType = nodeInfo && nodeInfo.nodeType
    const nodeVersion = nodeInfo && nodeInfo.nodeVersion
    const nodeCalcSuccessExpression = nodeInfo && nodeInfo.nodeCalcSuccessExpression

    const value = {
        nodeId: nodeId,
        nodeLabel: nodeLabel,
        nodeType: nodeType,
        nodeVersion: nodeVersion,
        nodeCalcSuccessExpression: nodeCalcSuccessExpression,
        err: {
            name: err && err.name,
            message: typeof err === 'string' ? err : err && err.message,
            stack: err && err.stack,
        },
        vm: {
            tag: vm && vm.$vnode && vm.$vnode.tag,
            componentTag: vm && vm.$vnode && vm.$vnode.componentOptions && vm.$vnode.componentOptions.tag,
            data: getData(vm && vm.$data),
            props: getData(vm && vm.$props)
        },
        info,
    };

    // console.info(`[main.js-sendErrorInfo-${from}]`, `[${nodeType}@${nodeVersion}-${nodeId}]`, value)

    marketingTraceLog(
        "source",
        from,
        "vue",
        JSON.stringify(value)
    );
}

var _oldOnError = Vue.config.errorHandler;
Vue.config.errorHandler = function (err, vm, info) {
    sendErrorInfo('errorHandler', err, vm, info)
    const {
        message,
        name } = err
    fmtErrInfo({ name, errorMessage: message }, '_VueGlobalError', vm)
    if (typeof _oldOnError === "function") {
        _oldOnError.call(this, err, vm, info);
    }
};

var _oldOnWarn = Vue.config.warnHandler;
Vue.config.warnHandler = function (err, vm, info) {
    sendErrorInfo('warnHandler', err, vm, info)
    if (typeof _oldOnWarn === "function") {
        _oldOnWarn.call(this, err, vm, info);
    }
};

Vue.prototype.$http = request
Vue.prototype.api = api
Vue.prototype.allBridge = {
    /**
     * 等待allBridge加载完成在执行指定动作
     */
    allReadydo: allReadydo
}
Vue.prototype.sendErrorInfo = sendErrorInfo

window.ALLEWebSite = true
window.$jsdk_loaded_list = {
    // 微信jsdk https://res.wx.qq.com/open/js/jweixin-1.6.0.js
    weixin_js: true,
    // 微信小程序通信 jsdk https://file.40017.cn/touchweixinqq/signal/correspond-1.0.1.js?v=202012021
    weixin_signal_corespond_js: true,
    // 微信分享相关授权 https://appnew.ly.com/fed/AjaxHelper/GetLyWeChatCode.ashx
    weixin_get_ly_wechat_code: true,
    // 同程APP bridge http://appnew.t.ly.com/fed/webapp/jsduck/doc/index.html#!/api
    tc_bridge_js: true,
    // 快应用 bridge http://wiki.17usoft.com/pages/viewpage.action?pageId=42541044
    quickapp_bridge_js: true,
    // 百度小程序 jsdk https://smartprogram.baidu.com/docs/develop/component/open_web-view/
    baiduapp_swan_js: true,
    // 数据中心埋点框架 https://vstlog.17u.cn/vst.ashx
    track_vst_ashx: true
}
window.Vue = Vue
const router = new VueRouter(routes)
const app = window.app = new Vue({ // eslint-disable-line
    router,
    render: h => h(App)
})
function startApp() {
    if (startApp.started) return
    startApp.started = true

    new InitSentrt(Vue, router)

    mount()

    function mount() {
        window.all_start_timeStr = window.all_start_timeStr  || new Date().getTime()
        Object.defineProperty(window, 'EventHub', {
            get() { return window.app }
        })
        app.$mount('#app')

    }
}
startApp()

export default Vue
